import { render, staticRenderFns } from "./FormProductItem.vue?vue&type=template&id=a3bbcdcc"
import script from "./FormProductItem.vue?vue&type=script&lang=js"
export * from "./FormProductItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\dev\\hubee\\hubee-backoffice-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a3bbcdcc')) {
      api.createRecord('a3bbcdcc', component.options)
    } else {
      api.reload('a3bbcdcc', component.options)
    }
    module.hot.accept("./FormProductItem.vue?vue&type=template&id=a3bbcdcc", function () {
      api.rerender('a3bbcdcc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/marketing_place/product/FormProductItem.vue"
export default component.exports